import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AppConfigService} from '../../services/config.service';
import {DistributedStreamingRegistryService, StreamingModule} from '../streaming';
import {StreamingService} from '../streaming/streaming.service';
import {TooltipModule} from '../tooltip';
import {SystemStatusIndicatorComponent} from './system-status-indicator.component';
import {SYSTEM_STATUS_LOGGER_TOKEN} from './system-status-logger';
import {SYSTEM_STATUS_STREAMING_SERVICE_TOKEN, SystemStatusService} from './system-status.service';

@NgModule({
    imports: [
        CommonModule,
        TooltipModule,
        StreamingModule
    ],
    declarations: [
        SystemStatusIndicatorComponent
    ],
    exports: [
        SystemStatusIndicatorComponent
    ],
    providers: [

        // Use StreamingService with appConfig.api.systemStatusStreaming option for Online status monitoring.
        {
            provide:    SYSTEM_STATUS_STREAMING_SERVICE_TOKEN,
            useFactory: (
                            distributedStreamingRegistryService: DistributedStreamingRegistryService,
                            appConfigService: AppConfigService
                        ): StreamingService | undefined =>

                            // Allow not using WS for system status indicator
                            appConfigService.api['systemStatusStreaming']
                                ? distributedStreamingRegistryService
                                    .getStreamingServiceInjector('systemStatusStreaming')
                                    .get(StreamingService)
                                : undefined,
            deps:       [DistributedStreamingRegistryService, AppConfigService]
        },

        SystemStatusService,
        {
            provide:     SYSTEM_STATUS_LOGGER_TOKEN,
            useExisting: SystemStatusService
        }
    ]
})
export class SystemStatusIndicatorModule {}
